module.exports = __webpack_public_path__ + "img/(12).6706e604.jpg";